<app-header
    [title]="'SETTINGS'"
    [showHomeButton]="true"
    [showTitle]="true">
</app-header>
<div class="settings-container">
  <form class="settings-form">
    <div class="form-group">
      <label for="username" class="form-label">Username</label>
      <input type="text" id="username" [(ngModel)]="username" name="username" placeholder="eg QUID201555" class="form-control">
    </div>
    <div class="form-group">
      <label for="password" class="form-label">Password</label>
      <input type="password" id="password" [(ngModel)]="password" name="password" placeholder="Password" class="form-control">
    </div>
    <button class="btn btn-primary" (click)="saveSettings()">Save Settings</button>
    <hr>
    <div class="form-group">
      <label for="environment" class="form-label">Environment</label>
      <select id="environment" [(ngModel)]="environment" name="environment" class="form-select">
        <option></option>
        <option *ngFor="let option of environmentOptions">{{ option }}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="save-photos" class="form-label">Save photos to camera roll</label>
      <select id="save-photos" [(ngModel)]="savePhotos" name="savePhotos" class="form-select">
        <option></option>
        <option *ngFor="let option of savePhotosOptions">{{ option }}</option>
      </select>
    </div>
    <button class="btn btn-primary" (click)="onSaveDetails()">Save Settings</button>
    <hr>
    <div class="form-group">
      <label for="dev-mode" class="form-label">Development Mode</label>
      <select id="dev-mode" [(ngModel)]="devModeOnOff" name="devModeOnOff" class="form-select">
        <option></option>
        <option *ngFor="let option of devModeOnOffOptions">{{ option }}</option>
      </select>
    </div>
  </form>
</div>
<footer class="footer border-top" style="height: 30px;"></footer>